import { useContext } from 'react';
import { MediaCoreContext } from '../index';

export default function useMediaCoreContext() {
  const context = useContext(MediaCoreContext);
  if (!context) {
    throw new Error('useMediaCoreContext must be used within a MediaCoreProvider');
  }
  return context;
}